import { render, staticRenderFns } from "./AvatarCreator.vue?vue&type=template&id=136fb244&scoped=true"
import script from "./AvatarCreator.vue?vue&type=script&lang=js"
export * from "./AvatarCreator.vue?vue&type=script&lang=js"
import style0 from "./AvatarCreator.vue?vue&type=style&index=0&id=136fb244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136fb244",
  null
  
)

export default component.exports